import { GetStaticProps, NextPage } from 'next'
import React from 'react'
import { ContentPage } from 'src/components/ContentPage/ContentPage'
import { THEME } from 'src/config/config'
import { apolloSdk } from 'src/graphql/apolloSdk'

type Props = {
  slug: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  content: any
}

const Content: NextPage<Props> = ({ content, slug }) => {
  return <ContentPage slug={slug} content={content} origin={`/contents/${slug}/`} />
}

export default Content

export const getStaticProps: GetStaticProps<Props> = async ({ params }) => {
  const slug = params?.slug as string | undefined
  if (!slug || THEME === 'ilta') return { revalidate: 60, notFound: true }

  try {
    const { contentBySlug: content } = await apolloSdk.contentBySlug({ slug })

    if (!content) return { revalidate: 60, notFound: true }

    const attributes = content?.content?.attributes || null

    return {
      props: {
        slug,
        content: {
          ...content,
          content: {
            ...content.content,
            attributes,
          },
        },
      },
      revalidate: 60,
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error fetching content:', error)
    return {
      notFound: true,
      revalidate: 60, // Reattempt fetching during the next static regeneration
    }
  }
}

export async function getStaticPaths() {
  try {
    const { contents } = await apolloSdk.allContentSlugs({ start: 0 })
    const result = contents?.data || []

    const paths = result?.filter((item) => !!item).map((item) => ({ params: { slug: item?.attributes?.slug } }))
    return {
      paths,
      fallback: 'blocking',
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error fetching content slugs:', error)
    return {
      paths: [],
      fallback: 'blocking',
    }
  }
}
